<template>
  <div
      class="io-text"
      :class="classes"
      :style="style"
  >
    <slot></slot>
  </div>
</template>

<script lang="ts" setup>
import {
  computed, inject,
} from 'vue';

const props = withDefaults(defineProps<{
  textAlign?: string
  color?: string
  fontSize?: string
  colorLg?: string
}>(), {
  textAlign: 'center',
  color: 'dark',
  fontSize: 'regular',
  colorLg: 'dark',
});

const alignment = inject<string>('cardItemsAlign', props.textAlign);

const classes = computed(() => {
  const textClasses = [];

  textClasses.push(`color-${props.color}`);
  textClasses.push(`color-lg-${props.colorLg}`);
  textClasses.push(`fs-${props.fontSize}`);

  return textClasses;
});

const style = computed(() => {
  const styles = {} as Record<string, string>;

  if (alignment !== 'inherit') {
    styles['--base-text-align'] = props.textAlign as string;
  }

  return styles;
});
</script>

<style lang="scss">
@import "src/scss/component-helpers";

.io-text {
  text-align: var(--base-text-align);
  overflow-wrap: anywhere;

  &, > p {
    @include poppins;
    line-height: 1.6;
  }

  b, strong {
    @include poppins(null, 700);

    em, i {
      font-family: inherit;
      font-weight: inherit;
      font-style: italic;
    }
  }

  em, i {
    font-family: inherit;
    font-weight: inherit;
    font-style: italic;

    b, strong {
      @include poppins(null, 700);
      font-style: italic;
    }
  }

  a:not(.base-button) {
    color: var(--color-brand-primary);
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
